import {Suggest} from '@logistics-frontend/blocks/lpc/suggest'
import {SuggestObjectAction} from '@yandex-taxi/js-integration-api'
import {AsyncStatus, isGeoObject, isPart, useSuggestQuery} from '@yandex-taxi/react-integration-api'
import React, {useCallback} from 'react'

import {useInputAddress as useAddress} from '../../components/map-bounds'
import {CLASS_FOR_SCROLL_TO_ERROR} from '../../consts'
import {useAddressGoalCallback} from '../metrika'

export type Props = {
  index: number
  length: number
  placeholder?: string
  validate?: boolean
}

const Address: React.FC<Props> = ({index, length, placeholder, validate = true}) => {
  const [{value, touched, error: draftError}, {setValue, setTouched}] = useAddress(index)
  const {status, suggest, error: queryError} = useSuggestQuery(index)
  const goalCallback = useAddressGoalCallback(index, length)
  const blurHandler = useCallback(() => {
    setTouched()
    goalCallback('Address')
  }, [goalCallback, setTouched])
  const focusHandler = useCallback(() => setTouched(false), [setTouched])

  const part = isPart(value) ? value : undefined
  const geoObject = isGeoObject(value) ? value : undefined
  const inputValue = geoObject?.title.text || part
  const options = suggest?.filter(obj => obj.action !== SuggestObjectAction.SUBSTITUTE)
  const loading = status === AsyncStatus.PENDING
  const errorText: string | undefined = validate && touched && draftError ? draftError : undefined
  // покажем ошибку запроса, если такая есть, иначе покажем ошибку валидации
  const helperText = status === AsyncStatus.ERROR && queryError?.message ? queryError.message : errorText

  return (
    <Suggest
      className={helperText ? CLASS_FOR_SCROLL_TO_ERROR : null}
      geoObject={geoObject}
      helperText={helperText}
      loading={loading}
      onChange={setValue}
      onInputBlur={blurHandler}
      onInputChange={setValue}
      onInputFocus={focusHandler}
      part={inputValue}
      placeholder={placeholder}
      suggest={options}
    />
  )
}

export default Address
